import './App.css';
import "./bootstrap.min.css"
import Home from './screens/Home';
import { Routes, Route, Navigate } from 'react-router-dom';

import LoginScreen from "./AdminScreens/LoginScreen";
import BlogsScreen from "./AdminScreens/BlogsScreens/BlogsScreen";
import AdminScreen from "./AdminScreens/AdminScreen";

import NotFound from "./screens/NotFound"

import LocationScreen from './screens/LocationScreens/LocationScreen';
import LocationPages from "./component/LocationPages_/LocationPages"
import ThankYou from './screens/ThankYou';
import Membership from './screens/Membership';
import Articleinner from './screens/Articleinner';
import Team from './screens/Team';
import DnaTesting from './screens/ServicesPages/DnaTesting';
import TeamIndividual from './screens/TeamIndividual';
import BoostShoot from './screens/ServicesPages/BoostShoot';
import Audiology from './screens/ServicesPages/Audiology';
import SportsMedicine from './screens/ServicesPages/SportsMedicine';
import OrthopaedicClinic from './screens/ServicesPages/OrthopaedicClinic';
import GynoUroClinic from './screens/ServicesPages/GynoUroClinic';
import PelvicFloorTherapy from './screens/ServicesPages/PelvicFloorTherapy';
import MedicalAesthetics from './screens/ServicesPages/MedicalAesthetics';
import GHAP from './screens/ServicesPages/GHAP';
import GeriatricGHAP from './screens/ServicesPages/GeriatricGHAP';
import GlobalMedicalConsulting from './screens/ServicesPages/GlobalMedicalConsulting';
import NaturopathicMedicine from './screens/ServicesPages/NaturopathicMedicine';
import Service from './screens/Service';
import MensPage from './screens/MensPage';
import WomensPage from './screens/WomensPage';
import ArticleMain from './screens/ArticleMain';
import ViaSure from './screens/ViaSure';
import PrivacyPolicy from './screens/PrivacyPolicy';
import TermofServices from './screens/TermofServices';
import BookConsultationForm from './screens/BookConsultationForm';
import Contact from './screens/Contact';
import LandingPage from './screens/LandingPage';
import LandingPageTwo from './screens/LandingPageTwo';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate to="/" replace={true}/>} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/book-a-consultation/:id" element={<BookConsultationForm />} />

        <Route path="/article-main" element={<ArticleMain />} />
        <Route path="/article/:id" element={<Articleinner />} />
        <Route path="/service" element={<Service />} />

        {/* SERVICES Pages  */}
        <Route path="/iv-therapy-boost-shots" element={<BoostShoot />} />
        <Route path="/dna-clinical-testing" element={<DnaTesting />} />
        <Route path="/naturopathic-medicine" element={<NaturopathicMedicine />} />
        <Route path="/audiology" element={<Audiology />} />
        <Route path="/sports-medicine" element={<SportsMedicine/>} />
        <Route path="/orthopaedic-clinic" element={<OrthopaedicClinic/>} />
        {/* <Route path="/gyno-uro-clinic" element={<GynoUroClinic/>} /> */}
        {/* <Route path="/pelvic-floor-therapy" element={<PelvicFloorTherapy/>} /> */}
        <Route path="/medical-aesthetics" element={<MedicalAesthetics/>} />
        <Route path="/aging-wellness-clinic" element={<GHAP/>} />
        <Route path="/geriatric-health-assessment-program" element={<GeriatricGHAP/>} />
        <Route path="/global-medical-consulting" element={<GlobalMedicalConsulting/>} />

        <Route path="/team" element={<Team />} />
        <Route path="/team-individual/:id" element={<TeamIndividual />} />
       
        {/* <Route path="/mens" element={<MensPage />} />
        <Route path="/women" element={<WomensPage />} /> */}
        {/* <Route path="/ed-treatment" element={<ViaSure />} /> */}
        <Route path="/contact" element={<Contact />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-conditions" element={<TermofServices />} />

        <Route path="/admin" element={<AdminScreen />} />
        <Route path="/admin/blogs" element={<BlogsScreen />} />
        <Route path="/login" element={<LoginScreen />} />

        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="*" element={<NotFound />} />

        <Route path='/location/:slug' element={<LocationPages />} />
        <Route path='/admin/location-pages' element={<LocationScreen />}/>

        <Route path='/personalize-care-membership' element={<LandingPage />} />
        <Route path='/executive-membership' element={<LandingPageTwo />} />
      </Routes>
    </div>
  );
}

export default App;


